import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import OrderContentFelge from './OrderContentFelge';
import OrderContentProduct from './OrderContentProduct';
import OrderContentReifen from './OrderContentReifen';
import OrderContentService from './OrderContentService';
import { userSelector } from '../../../modules/selectors/auth';

function OrderContent({ product, markenStandort, orderId, orderNumber }) {
    const user = useSelector(userSelector);
    const images = useMemo(() => {
        const blobUrl = product?.isOwnArticle ? '' : 'https://techno-images.s3.eu-central-1.amazonaws.com/images/articles/';
        const bildUrl = product?.isOwnArticle ? '' : 'https://www.tibsonline.de/AddvMultimedia/';
        let images = [];

        if (product?.blobdatei) {
            images.push(blobUrl + product?.blobdatei);
        } else if (product?.bilddatei) {
            images.push(bildUrl + product?.bilddatei);
        }
        if (product?.blobdatei2) {
            images.push(blobUrl + product?.blobdatei2);
        } else if (product?.bilddatei2) {
            images.push(bildUrl + product?.bilddatei2);
        }
        if (product?.blobdatei3) {
            images.push(blobUrl + product?.blobdatei3);
        } else if (product?.bilddatei3) {
            images.push(bildUrl + product?.bilddatei3);
        }

        if (!images.length && product?.images) {
            images = product?.images.map(image => image)// `https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${image.name}`);
        }

        return images;
    }, [product]);

    const currentOrderState = useMemo(() => {
        return product?.orderStates?.find(state => state?.status === product?.orderStatus);
    }, [product]);

    const orderStatusLabel = useMemo(() => {
        if (currentOrderState?.statusLabelFrontend) return currentOrderState.statusLabelFrontend;
        if (product?.orderStatusLabel) return product.orderStatusLabel;
        if (product?.orderStatus === 'initiated') return 'Widerruf eingeleitet';
        return null;
    }, [currentOrderState, product?.orderStatus, product?.orderStatusLabel]);

    const frontEndOrderActions = useMemo(() => {
        return currentOrderState?.orderActions?.filter(action => !action?.isBackend && action.requiresModal) || [];
    }, [currentOrderState]);

    const showRetoureLink = !['open', 'initiated', 'cancelled', 'completedProductExchange', 'changeAppointment', 'reversed', 'refunded'].includes(
        product.orderStatus
    );

    const showWiderrufButton = product.orderStatus === 'completed';

    const widerrufInitialValues = useMemo(() => ({
        name: user ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() : '',
        orderNumber: String(orderNumber ?? orderId),
        orderId: orderId ? String(orderId) : '',
        email: user?.email ?? '',
        productId: product?._id ? String(product._id) : '',
    }), [user, orderId, orderNumber, product?._id]);

    switch (product.elementType) {
        case 'felge':
            return (
                <OrderContentFelge
                    currentOrderState={currentOrderState}
                    orderStatusLabel={orderStatusLabel}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                    showWiderrufButton={showWiderrufButton}
                    widerrufInitialValues={widerrufInitialValues}
                />
            );
        case 'reifen':
            return (
                <OrderContentReifen
                    currentOrderState={currentOrderState}
                    orderStatusLabel={orderStatusLabel}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                    showWiderrufButton={showWiderrufButton}
                    widerrufInitialValues={widerrufInitialValues}
                />
            );
        case 'service':
            return (
                <OrderContentService
                    currentOrderState={currentOrderState}
                    orderStatusLabel={orderStatusLabel}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                    widerrufInitialValues={widerrufInitialValues}
                />
            );
        case 'product':
            return (
                <OrderContentProduct
                    currentOrderState={currentOrderState}
                    orderStatusLabel={orderStatusLabel}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                    showWiderrufButton={showWiderrufButton}
                    widerrufInitialValues={widerrufInitialValues}
                />
            );
        default:
            return (
                <OrderContentProduct
                    currentOrderState={currentOrderState}
                    orderStatusLabel={orderStatusLabel}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                    showWiderrufButton={showWiderrufButton}
                    widerrufInitialValues={widerrufInitialValues}
                />
            );
    }
}

export default OrderContent;
